import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const XRefContext = createContext(undefined);
export function useXRefState() {
    var _a;
    const state = (_a = useContext(XRefContext)) !== null && _a !== void 0 ? _a : { inCrossRef: false, remote: false };
    return state;
}
// Create a provider for components to consume and subscribe to changes
export function XRefProvider({ remote, url, dataUrl, children, }) {
    const parent = useXRefState();
    const value = {
        inCrossRef: true,
        remote: remote !== null && remote !== void 0 ? remote : parent.remote,
        url: url !== null && url !== void 0 ? url : parent.url,
        dataUrl: dataUrl !== null && dataUrl !== void 0 ? dataUrl : parent.dataUrl,
    };
    if (value.remote && !value.url) {
        value.remote = false;
    }
    return _jsx(XRefContext.Provider, { value: value, children: children });
}
